import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-online-order',
  templateUrl: './online-order.component.html',
  styleUrls: ['./online-order.component.scss']
})
export class OnlineOrderComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
